import { useState } from 'react'
import { Button } from '../common'
import { clientService } from '../../services'

interface ClientAccessLinkProps {
  accessToken: string
  onRegenerate?: () => Promise<void>
}

export function ClientAccessLink({
  accessToken,
  onRegenerate,
}: ClientAccessLinkProps) {
  const [copied, setCopied] = useState(false)
  const [isRegenerating, setIsRegenerating] = useState(false)

  const accessLink = clientService.getClientAccessLink(accessToken)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(accessLink)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  const handleRegenerate = async () => {
    if (!onRegenerate) return
    setIsRegenerating(true)
    try {
      await onRegenerate()
    } finally {
      setIsRegenerating(false)
    }
  }

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Client Access Link
      </label>
      <div className="flex gap-2">
        <input
          type="text"
          value={accessLink}
          readOnly
          className="flex-1 px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm text-gray-600 font-mono"
        />
        <Button
          onClick={handleCopy}
          variant={copied ? 'primary' : 'outline'}
          className="min-w-[80px]"
        >
          {copied ? 'Copied!' : 'Copy'}
        </Button>
      </div>
      <p className="mt-2 text-xs text-gray-500">
        Share this link with your client. They can access their assigned
        programs without creating an account.
      </p>
      {onRegenerate && (
        <button
          onClick={handleRegenerate}
          disabled={isRegenerating}
          className="mt-2 text-xs text-blue-600 hover:text-blue-800 disabled:opacity-50"
        >
          {isRegenerating ? 'Regenerating...' : 'Generate new link'}
        </button>
      )}
    </div>
  )
}
